module.exports = __webpack_public_path__ + "img/logo.6722afa6.jpg";